import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useLocalStorage } from "~/Hooks/useLocalStorage";
import { useNotification } from "~/Hooks/useNotification";
import { useQuery } from "~/Hooks/useQuery";
import { post, put } from "~/Services";
import { passengerHost } from "~/Utils";
import { decodeHTML } from "~/Utils/CommonUtils";
import { fields } from "../../constants";
import { useLandingPageContenDocumentDetails } from "./DineCategories.hooks";

export const AddEditDineCatPageContent = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();

  const {
    data: editPageContent,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchCategories,
  } = useLandingPageContenDocumentDetails(query.get("editId") || "");

  const {
    data: editPageContentById,
    isLoading: isLoadingLocs,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  const [currentAirport] = useLocalStorage("currentAirport", null);

  useEffect(() => {
    const activeTab = query.get("activeTab");
    if (activeTab === "pageHeading") {
      refetchCategories();
    }
    if (query.get("id")) {
      refetchDocument();
    }
    if (query.get("editId")) {
      refetchCategories();
    }
  }, [query.get("activeTab"), query.get("editId"), query.get("id")]);

  const formConfig: FormConfig = {
    initialValues: {
      image: editPageContentById
        ? editPageContentById.payload?.image
          ? [
              {
                uid: "-1",
                name: "image.jpg",
                status: "done",
                url: editPageContentById.payload.image,
              },
            ]
          : []
        : editPageContent?.image
          ? [
              {
                uid: "-1",
                name: "image.jpg",
                status: "done",
                url: editPageContent.image,
              },
            ]
          : [],

      banner_image: editPageContentById
        ? editPageContentById.payload?.banner_image
          ? [
              {
                uid: "-1",
                name: "banner_image.jpg",
                status: "done",
                url: editPageContentById.payload.banner_image,
              },
            ]
          : []
        : editPageContent?.banner_image
          ? [
              {
                uid: "-1",
                name: "banner_image.jpg",
                status: "done",
                url: editPageContent.banner_image,
              },
            ]
          : [],

      name: editPageContentById
        ? decodeHTML(editPageContentById.payload?.name)
        : editPageContent
          ? decodeHTML(editPageContent?.name)
          : "",

      name_ms: editPageContentById
        ? decodeHTML(editPageContentById.payload?.name_ms)
        : editPageContent
          ? decodeHTML(editPageContent?.name_ms)
          : "",

      name_zh: editPageContentById
        ? decodeHTML(editPageContentById.payload?.name_zh)
        : editPageContent
          ? decodeHTML(editPageContent?.name_zh)
          : "",

      description: editPageContentById
        ? decodeHTML(editPageContentById.payload?.description)
        : editPageContent
          ? decodeHTML(editPageContent?.description)
          : "",

      description_ms: editPageContentById
        ? decodeHTML(editPageContentById.payload?.description_ms)
        : editPageContent
          ? decodeHTML(editPageContent?.description_ms)
          : "",

      description_zh: editPageContentById
        ? decodeHTML(editPageContentById.payload?.description_zh)
        : editPageContent
          ? decodeHTML(editPageContent?.description_zh)
          : "",

      link: editPageContentById
        ? decodeHTML(editPageContentById.payload?.link)
        : editPageContent
          ? decodeHTML(editPageContent?.link)
          : "",

      airport: (decodeHTML(editPageContentById?.payload?.airport) || decodeHTML(editPageContent?.airport) || "")
        .split(",")
        .map((a: any) => a.trim())
        .filter(Boolean),

      published: editPageContentById
        ? decodeHTML(editPageContentById.payload?.published)
        : editPageContent
          ? decodeHTML(editPageContent?.published)
          : "",
    },

    fields: fields.dineCategoriesPageContent,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    console.log("data-123", data);

    let imageKeys: any = ["image", "banner_image"];
    for (const key of imageKeys) {
      const field = data[key];

      try {
        if (field?.[0]?.originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "PASSENGER");
          const res: any = await post("management/upload-file", formData);
          if (res) data[key] = res.response.data;
        } else if (field?.[0]?.url) {
          data[key] = field[0].url;
        } else if (Array.isArray(field) && field.length === 0) {
          data[key] = "";
        } else if (!field) {
          data[key] = "";
        }
      } catch (error) {
        console.error(`Error handling image field ${key}:`, error);
      }
    }

    if (Array.isArray(data.airport)) {
      data.airport = data.airport.join(", ");
    }

    const payload = {
      action,
      method,
      module: "Shop & Dine",
      subModule: "dine_dineCategories_dineCategoriesPageContent",
      type: "DEDICATED",
      application: "PASSENGER_ECMS",
      airportName: currentAirport,
      reviewNotes,
      appList: [
        {
          appName: "PASSENGER_ECMS",
          apiUrl,
        },
      ],
      payload: {
        ...(action === "UPDATE" && {
          id: editPageContent?.id || editPageContentById?.payload?.id,
        }),
        ...data,
        type: "dine",
      },
      status,
    };

    console.log("Final Payload:", payload);

    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch(() => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post(`/management/publish`, payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch(() => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <ContentWrapper
      title={`${query.get("id") || query.get("editId") ? "Edit" : "Add New"} Page Content`}
      showBack
    >
      <DynamicForm
        isLoading={drilldownLoading || isLoadingLocs}
        config={formConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            `${query.get("editId") || query.get("type") === "update" ? `${passengerHost}/api/shop-category/${editPageContent?.id || editPageContentById?.payload?.id}` : `${passengerHost}/api/shop-dine-services-items-crud-data`}`,
            `${query.get("editId") || query.get("type") === "update" ? "UPDATE" : "CREATE"}`,
            `${query.get("editId") || query.get("type") === "update" ? "PATCH" : "POST"}`,
            buttonValue == "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
        defaultReviewNotes="Kindly review this Shop & Dine"
      />
    </ContentWrapper>
  );
};
